import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// The Cases index counterpart of duplicate_course_modal_controller: one modal per page, pointed
// at whichever row's Duplicate button opened it.
export default class extends Controller {
  static targets = ["modal", "form", "caseTitle", "nameInput"];
  static values = {
    baseUrl: String
  };

  connect() {
    this.handleModalHidden = this.handleModalHidden.bind(this);

    if (this.hasModalTarget) {
      this.modalTarget.addEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener("hidden.bs.modal", this.handleModalHidden);
    }
  }

  open(event) {
    event.preventDefault();

    const { caseId, caseTitle } = event.currentTarget.dataset;

    this.formTarget.action = this.baseUrlValue.replace(":id", caseId);
    this.caseTitleTarget.textContent = caseTitle;
    this.nameInputTarget.value = `${caseTitle} (Copy)`;

    Modal.getOrCreateInstance(this.modalTarget).show();

    this.modalTarget.addEventListener("shown.bs.modal", () => {
      this.nameInputTarget.focus();
      this.nameInputTarget.select();
    }, { once: true });
  }

  handleModalHidden() {
    this.nameInputTarget.value = "";
  }
}
